import type { FC } from 'react';
import type { DeviceType } from '../agent';
import { getAreaSearchParams } from '../area';
import { useOnVisible } from '../hooks/useOnVisible';
import { CARD_SHELL_CLASSNAME } from '../pristips/dimensions';
import { trackClickSoldMap, trackViewSoldMap } from '../utils/tracking';
import { CardAction } from './CardAction';

interface Props {
    deviceType: DeviceType;
    searchParams: URLSearchParams;
}

const SOLD_MAP_URL = 'https://www.finn.no/map/realestate/sold';

export const SoldMapCard: FC<Props> = ({ deviceType, searchParams }) => {
    const cardRef = useOnVisible<HTMLAnchorElement>(trackViewSoldMap);
    const areaSearchParams = getAreaSearchParams(searchParams);
    const soldMapUrl = `${SOLD_MAP_URL}?${areaSearchParams.toString()}`;

    return (
        <a
            ref={cardRef}
            className={`${CARD_SHELL_CLASSNAME} flex flex-col s-bg-subtle pt-16 px-16 pb-[72px]`}
            href={soldMapUrl}
            target={deviceType === 'desktop' ? '_blank' : '_top'}
            rel="noopener noreferrer"
            onClick={trackClickSoldMap}
            onAuxClick={(e) => {
                if (e.button === 1) trackClickSoldMap();
            }}
        >
            <p className="text-l font-bold s-text">Hva ble nabohuset solgt for?</p>
            <p className="text-s s-text-subtle">I solgtpriskartet kan du sjekke hva boliger er solgt for der du bor.</p>
            <CardAction className="s-bg-primary hover:s-bg-primary-hover s-text-inverted">Åpne kart</CardAction>
        </a>
    );
};
